module.exports = __webpack_public_path__ + "static/media/14.e23797df.jpeg";